// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__8GbG-","form":"styles_form__sii7d"};